<template>
  <main class="list">
		<header class="page header">
			<div class="content row">
		<div class=" col-4">
  		<h4 class="mt-3 ml-5 light">Items</h4>
		</div>
		<div class="col-8 filters">
  		<router-link
			v-if="Data.featureEnabled('create',Data)"
			:to="{ path: '/items/edit/new'}"
			tag="button"
			class="btn btn-primary">
			New Item
  		</router-link>		 
		  <multiselect
			v-if="editor_type.value == 'specifics'"
			v-model="locale"
			label="label"
			:options="[{label: 'UK', value: 'UK'}, {label: 'US', value: 'US'}]"
			:allow-empty="false"
			:show-labels="false"
			@select="changeLocale"
		  /> 
  		<multiselect
			v-model="editor_type"
			label="label"
			:options="options"
			:allow-empty="false"
			:show-labels="false"
			@select="changeEditor"
  		/>


  		<button v-if="this.$route.query.s" v-on:click.prevent="clear" class="btn btn-primary">Clear</button>
  		<div class="input-group">
						<input
  			type="text"
  			class="form-control"
  			placeholder="Search"
  			ref="search_field"
  			:value="this.$route.query.s"
  			v-on:keyup.enter="search"
  			/>
			<span class="input-group-append"  v-on:click="search">
				<span class="input-group-text">
					<i class="fas fa-search"></i>
				</span>
			</span>
		</div>
		</div>
			</div>
		</header>
	<Editor
  	:type="editor_type"
  	:search="search_query"
  	@selectTrigger="editCollect"
  	:key="editorKey"
  	:fields="fields"
  	/>
	<div v-if="this.editCollection.length > 0" class="editCollection row">
  	<div class="col-6">
  		<div class="my-1"><b>{{this.editCollection.length }}</b> items selected for editing.</div>
  	</div>
  	<div class="col-6">
		<button
		v-if="Data.featureEnabled('delete',Data)"
  		v-on:click.prevent="remove"
  		class="btn btn-sm btn-danger my-1 mr-3 pull-right">
  		Delete Selected
		</button>
		<router-link
  		:to="{ path: `/items/edit/${this.editCollection.join(',')}`}"
  		tag="button"
  		class="btn btn-sm btn-primary my-1 mr-3 pull-right">
  		Edit Selected
		</router-link>
  	</div>
	</div>
  </main>
</template>

<script>
import Editor from './edit-inline.vue';
import Data from  '../../main';
import { global_emits } from '../../main';

export default {
	name: 'ItemList',
	components: {
		Editor,
	},
	data() {
		return {
			search_query: this.$route.query.s,
			editCollection: [],
			editor_type: {},
			locale: {label: 'US', value: 'US'},
			editorKey: 0,
			fields: [],
			options: [
				{label: 'Item Data Editor', value: 'data'},
				{label: 'ID Info Editor', value: 'asin'},
				{label: 'Item Specifics', value: 'specifics'},
				// {label: 'Price Editor', value: 'price'},
				{label: 'Stock Editor', value: 'stock'},
				{label: 'Channel Selector', value: 'onsite'},
			],
		};
	},
	computed: {
		Data() {
			return Data;
		},
	},
	mounted: function() {
		if (this.$route.params.editor) {
			this.editor_type = this.options.find( (o) => o.value === this.$route.params.editor );
		} else {
			this.editor_type = {label: 'Item Data Editor', value: 'data'};
		}

		this.$Progress.start();
		this.$axios.get(`/fields`)
			.then((response) => {
				this.fields = response.data;
			})
			.catch((error) => {
				console.log(error);
			})
			.finally(()=>{
				this.$Progress.finish();
			});
	},

	methods: {
		search: function(e) {
			this.$router.push({path: `/items/${this.$route.params.editor}`, query: {s: this.$refs.search_field.value}}, () => {});
			this.search_query = this.$refs.search_field.value;
		},
		clear: function() {
			this.$router.push({path: `/items/${this.$route.params.editor}`});
			this.search_query = '';
		},
		changeEditor: function(s) {
			this.editor_type = s;
			this.$router.push({path: `/items/${s.value}`});
		},
		changeLocale: function(s) {
			this.locale = s;
			global_emits.$emit('locale_changed', { locale: s });
		},
		
		editCollect: function(e) {
			this.editCollection = e;
		},
		remove: function(e) {
			const c = confirm('Delete selected?');
			if (!c) return;

			this.$Progress.start();
			this.$axios.delete(`/item`, {
				params: {
					batch: this.editCollection,
				},
			})
				.then((response) => {
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'The item(s) has been deleted.',
						type: 'success',
					});
					//this.editorKey += 1;
					global_emits.$emit('item_deleted', {ids: this.editCollection.join(',') });
					this.editCollection = [];
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},
	},
};
</script>

<style scoped>
  .content .filters > *{
	max-width: 25%;
	margin: 10px;
	float:right;
  }
  .editCollection{
	position: fixed;
	background: #fff;
	bottom:0;
	width: 70%;
	margin-left: 15%;
  	border: 1px solid #ccc;
		z-index: 2
  }

</style>
